import type { RouteRecordRaw } from 'vue-router';

import getAffiliateNetworksRoutes from '@/features/affiliate-networks/getAffiliateNetworksRoutes';
import getAuthenticationRoutes from '@/features/authentication/getAuthenticationRoutes';
import getCampaignsRoutes from '@/features/campaigns/getCampaignsRoutes';
import { getFacebookRoutes } from '@/features/facebook/routes';
import getFilesRoutes from '@/features/files/getFilesRoutes';
import getLandingsRoutes from '@/features/landings/getLandingsRoutes';
import getMonitorRoutes from '@/features/monitor/getMonitorRoutes';
import getOffersRoutes from '@/features/offers/getOffersRoutes';
import getReportRoutes from '@/features/report/report-page/getReportRoutes';
import getRotationsRoutes from '@/features/rotations/getRotationsRoutes';
import getSettingsRoutes from '@/features/settings/getSettingsRoutes';
import getTrafficSourcesRoutes from '@/features/traffic-sources/getTrafficSourcesRoutes';
import getTrendsRoutes from '@/features/trends/getTrendsRoutes';
import getTriggersRoutes from '@/features/triggers/getTriggersRoutes';
import getUsersRoutes from '@/features/users/getUsersRoutes';

const StubPage = async () => import('@/pages/StubPage.vue');
const PageNotFound = async () => import('@/pages/PageNotFound.vue');
const GroupsPage = async () => import('@/pages/GroupsPage.vue');
const DomainsPage = async () => import('@/pages/DomainsPage.vue');
const ClicklogPage = async () => import('@/pages/ClicklogPage.vue');
const ConversionsPage = async () => import('@/pages/ConversionsPage.vue');
const UpdatePage = async () => import('@/pages/update/UpdatePage.vue');
const RollbackPage = async () => import('@/pages/rollback/RollbackPage.vue');

export default function getRoutes(): RouteRecordRaw[] {
  return [
    {
      name: '404',
      component: PageNotFound,
      meta: {
        title: '404 Not found',
      },
      path: '/404',
    },
    ...getCampaignsRoutes(),
    ...getRotationsRoutes(),
    ...getReportRoutes(),
    ...getAuthenticationRoutes(),
    ...getUsersRoutes(),
    ...getMonitorRoutes(),
    ...getAffiliateNetworksRoutes(),
    ...getOffersRoutes(),
    ...getLandingsRoutes(),
    ...getTrafficSourcesRoutes(),
    ...getTrendsRoutes(),
    ...getFilesRoutes(),
    ...getSettingsRoutes(),
    ...getFacebookRoutes(),
    {
      name: 'conversions',
      component: ConversionsPage,
      meta: {
        title: 'Conversions',
        useIn: ['navigation-tabs'],
      },
      path: '/conversions',
    },
    {
      name: 'clicklog',
      component: ClicklogPage,
      meta: {
        title: 'Clicklog',
        useIn: ['navigation-tabs'],
      },
      path: '/clicklog',
    },
    ...getTriggersRoutes(),
    {
      name: 'update',
      component: StubPage,
      meta: {
        title: 'Update',
        useIn: ['menu'],
      },
      path: '/update',
    },
    {
      name: 'domains',
      component: DomainsPage,
      meta: {
        title: 'Domains',
        useIn: ['menu'],
      },
      path: '/domains',
    },
    {
      name: 'groups',
      component: GroupsPage,
      meta: {
        title: 'Groups',
        useIn: ['menu'],
      },
      path: '/groups',
    },
    {
      name: 'update',
      component: UpdatePage,
      meta: {
        title: 'Update',
        useIn: ['menu'],
      },
      path: '/update',
    },
    {
      name: 'rollback',
      component: RollbackPage,
      meta: {
        title: 'Rollback',
        useIn: ['menu'],
      },
      path: '/rollback',
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/404',
    },
  ];
}
